import { render, staticRenderFns } from "./single-customer-dialog.vue?vue&type=template&id=25619d66"
import script from "./single-customer-dialog.vue?vue&type=script&lang=js"
export * from "./single-customer-dialog.vue?vue&type=script&lang=js"
import style0 from "./single-customer-dialog.vue?vue&type=style&index=0&id=25619d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/customer/single-customer-dialog.vue
// module id = null
// module chunks = 